import React, {
  FunctionComponent,
  useEffect,
  useState,
  useContext
} from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  CircularProgress,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Fade,
  FormControl,
  FormControlLabel,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import useStyles from "./styles";

import { ConfirmDialog } from "../../../components/dialogs/ConfirmDialog";
import { StoreMultiSelect } from "../../../components/selects/StoreMultiSelect";
import { PriorityMultiSelect } from "../../../components/selects/PriorityMultiSelect";
import { CategoryMultiSelect } from "../../../components/selects/CategoryMultiSelect";
import { Storage } from "../../../storage/productSync";
import { initialProductSyncFilters } from "../../../models/Filters";
import * as Products from "../../../api/productApi";
import { Alert, AlertTitle } from "@material-ui/lab";
import { DropzoneArea } from "material-ui-dropzone";
import * as ProductApi from "../../../api/productApi";
import { isOk } from "../../../result";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch } from "react-redux";
import { thunkFetchProductsV2 } from "../../../store/products/action";
import { Authenticated } from "../../../models/User";
import { UserContext } from "../../../UserProvider";
import { StoreSelector } from "../../../components/store-selector/StoreSelector";
import { StepButtons } from "../../dashboard/components/OnBoarding/components/StepButtons";
import { useI18n } from "../../../hooks/useI18n";

export const TenantProductSync: FunctionComponent = () => {
  const { t } = useI18n();
  const classes = useStyles();
  const dispatch = useDispatch();
  const currentUser = useContext(UserContext) as Authenticated;
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));

  const getStoredFilters = () => ({
    ...Storage.filters,
    productFilter:
      Storage.filters.productFilter === undefined
        ? 1
        : Storage.filters.productFilter
  });

  const [state, setState] = useState<any>({
    showFilters: false,
    selectedStores: [],
    filters: getStoredFilters(),
    validateDocumentOnly: true,
    uploading: false,
    uploadFinished: false,
    result: null,
    activeStep: 0,
    uploadSource:
      currentUser.tenant?.configuration?.pos &&
      currentUser.tenant?.configuration?.pos?.name
        ? undefined
        : "fromFile"
  });

  useEffect(() => {
    if (state.uploading) {
      if (state.uploadSource === "fromPos") {
        ProductApi.syncWithPos(state.selectedStores).then(result => {
          if (isOk(result)) {
            dispatch(thunkFetchProductsV2());

            return setState({
              ...state,
              uploading: false,
              uploaded: true,
              result: result.value
            });
          }

          return setState({
            ...state,
            uploading: false,
            uploaded: false,
            error: result.details.detail
          });
        });
      } else {
        ProductApi.uploadProductSyncDocument(
          state.validateDocumentOnly,
          state.file,
          state.selectedStores
        ).then(result => {
          if (isOk(result)) {
            dispatch(thunkFetchProductsV2());

            return setState({
              ...state,
              uploading: false,
              uploaded: true,
              result: result.value
            });
          }

          return setState({
            ...state,
            uploading: false,
            uploaded: false,
            error: result.details.detail
          });
        });
      }
    }
  }, [state.uploading]);

  const handleUpload = () => {
    return setState({
      ...state,
      uploading: true,
      file: state.file,
      result: [],
      error: undefined
    });
  };

  const handleNext = async () => {
    let activeStepIncrement = 1;
    if (state.activeStep === 0 && state.uploadSource === "fromPos") {
      activeStepIncrement = 2;
    }
    setState({ ...state, activeStep: state.activeStep + activeStepIncrement });
  };

  const handleBack = () => {
    let activeStepDecrement = 1;
    if (state.activeStep === 2 && state.uploadSource === "fromPos") {
      activeStepDecrement = 2;
    }

    setState({
      ...state,
      activeStep: state.activeStep - activeStepDecrement,
      error: undefined
    });
  };

  const handleDisable = () => {
    if (state.activeStep === 3) {
      return true;
    }

    if (
      state.activeStep === 1 &&
      state.uploadSource === "fromFile" &&
      !state.file
    ) {
      return true;
    }

    return false;
  };

  return (
    <>
      {state.activeStep === 0 && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 10
            }}
          >
            <Typography variant="h6" gutterBottom component="div">
              {t("common.messages.whatIsProductUpload")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={classes.helpTitle}
              style={{
                width: mobile ? "100%" : "80%",
                textAlign: "center"
              }}
            >
              {t("common.messages.productUploadDescription")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 10
            }}
          >
            <Typography variant="h6" gutterBottom component="div">
              {t("common.messages.whatHappensWhenUpload")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={classes.helpTitle}
              style={{
                width: mobile ? "100%" : "80%",
                textAlign: "center"
              }}
            >
              {t("common.messages.whatHappensWhenUploadDescription")}
            </Typography>
          </div>
          {currentUser.tenant?.configuration?.pos &&
            currentUser.tenant?.configuration?.pos?.name && (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 10,
                    marginBottom: 20
                  }}
                >
                  <Typography variant="h6" gutterBottom component="div">
                    {t("common.messages.differenceUploadPosFile")}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 30
                  }}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={classes.helpTitle}
                    style={{
                      width: mobile ? "100%" : "80%",
                      textAlign: "center"
                    }}
                  >
                    {t("common.messages.uploadingProductsFromPos")}
                    your products registered in your POS into the Storekey’s
                    Product catalogue and uploading your products{" "}
                    <b>{t("common.messages.fromFile")}</b> will import the
                    products into the Storekey’s Product catalogue. It will not
                    upload them to your POS.
                  </Typography>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={state?.uploadSource}
                      onChange={event => {
                        setState({
                          ...state,
                          uploadSource: event.target.value
                        });
                      }}
                    >
                      <FormControlLabel
                        value="fromPos"
                        control={<Radio />}
                        label={t("common.actions.uploadFromPos")}
                      />
                      <FormControlLabel
                        value="fromFile"
                        control={<Radio />}
                        label={t("common.actions.uploadFromFile")}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            )}
        </div>
      )}
      {state.activeStep === 1 && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 10
            }}
          >
            <Typography variant="h6" gutterBottom component="div">
              {t("common.messages.productFile")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 30
            }}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={classes.helpTitle}
              style={{
                width: mobile ? "100%" : "80%",
                textAlign: "center"
              }}
            >
              <List>
                <ListItem>
                  <ListItemText
                    primary={t(
                      "common.messages.downloadProductFileInstructions"
                    )}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t("common.messages.fillFileWithProducts")}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t("common.messages.saveFileInstructions")}
                  />
                </ListItem>
              </List>
            </Typography>
          </div>
          <div className={classes.downloadButtons}>
            <ButtonGroup
              variant="contained"
              color="primary"
              aria-label={t("common.tooltip.containedPrimaryButtonGroup")}
            >
              <Button
                onClick={() => {
                  window.open(
                    Products.getProductSyncDocumentUrl(state.filters)
                  );
                }}
              >
                {t("common.actions.downloadProductFile")}
              </Button>
            </ButtonGroup>
          </div>
          <div className={classes.fileUploadArea}>
            <DropzoneArea
              acceptedFiles={[".csv"]}
              dropzoneText={t("common.messages.dragDropProductFile")}
              showPreviewsInDropzone={true}
              useChipsForPreview
              filesLimit={1}
              onChange={files => {
                setState({
                  ...state,
                  file: files[files.length - 1],
                  uploaded: false,
                  result: null
                });
              }}
            />
          </div>
        </div>
      )}

      {state.activeStep === 2 && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 10
            }}
          >
            <Typography variant="h6" gutterBottom component="div">
              {t("common.messages.activateProductsInStore")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 30
            }}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={classes.helpTitle}
              style={{
                width: mobile ? "100%" : "80%",
                textAlign: "center"
              }}
            >
              {t("common.messages.activatingProductsMakesThemAvailable")}
              {t("common.messages.activateProductsDescription")}{" "}
              <b>"{t("common.navigation.stores")}"</b>.{" "}
              {t("common.messages.products")}
              can still be activated later on to make them available for
              purchase in the App.
            </Typography>
          </div>
          <StoreSelector
            selectedStoreIds={state.selectedStores}
            onSelectedStore={selectedStores =>
              setState({ ...state, selectedStores: selectedStores })
            }
          />
        </div>
      )}
      {state.activeStep === 3 && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 10
            }}
          >
            <Typography variant="h6" gutterBottom component="div">
              {t("common.messages.finalStep")}{" "}
              {state.uploadSource === "fromFile"
                ? t("common.messages.uploadFromFile")
                : t("common.messages.uploadFromPos")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 30
            }}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={classes.helpTitle}
              style={{
                width: mobile ? "100%" : "80%",
                textAlign: "center"
              }}
            >
              {t("common.messages.readyToUpload")}{" "}
              <b>{t("common.messages.uploadProductsButtonToUploadProcess")}</b>{" "}
              {t("common.messages.buttonToStartUpload")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 10
            }}
          >
            <Button variant="contained" color="primary" onClick={handleUpload}>
              {t("common.messages.uploadProducts")}
            </Button>
          </div>
          {state.uploaded && (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 30
                }}
              >
                {state.result.length === 0 ? (
                  <div>
                    <Alert severity="success">
                      <Typography variant="h6" gutterBottom component="div">
                        {t("common.messages.uploadStatusSuccess")}
                      </Typography>
                    </Alert>
                  </div>
                ) : (
                  <div>
                    <Alert severity="warning" style={{ marginBottom: 30 }}>
                      {t("common.messages.importSuccessfulWithErrors")}
                    </Alert>
                    <ExpansionPanel
                      variant={"outlined"}
                      className={classes.expansionPanel}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="errors-content"
                        id="errors-header"
                      >
                        <Typography>{t("common.messages.result")}</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <List>
                          {state.result.map((x: any) => (
                            <ListItem key={x}>
                              <ListItemText primary={x} />
                            </ListItem>
                          ))}
                        </List>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </div>
                )}
              </div>
            </div>
          )}
          {state.error && (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 30
                }}
              >
                <Alert severity="error">
                  <Typography variant="h6" gutterBottom component="div">
                    {t("common.messages.uploadStatusError")}
                  </Typography>
                </Alert>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 30
                }}
              >
                <Alert severity="error">
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={classes.helpTitle}
                    style={{
                      width: mobile ? "100%" : "80%",
                      textAlign: "center"
                    }}
                  >
                    {/* An error occured when updating your products - Please
                    contact Storekey for help */}
                    {state.error}
                  </Typography>
                </Alert>
              </div>
            </div>
          )}
        </div>
      )}
      <StepButtons
        nextDisabled={handleDisable()}
        backDisabled={state.activeStep === 0}
        onClickBack={handleBack}
        onClickNext={handleNext}
      />

      <Modal
        open={state.uploading}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Fade in={state.uploading}>
          <Card>
            <CardHeader
              title={t("common.messages.uploadingProducts")}
              titleTypographyProps={{ variant: "h5" }}
            />
            <CardContent className={classes.loading}>
              <CircularProgress />
            </CardContent>
          </Card>
        </Fade>
      </Modal>
    </>
  );
};
